import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { apiBaseUrlInterceptor } from './interceptors/api-base-url.interceptor';
//import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'

//import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CarouselModule } from 'primeng/carousel';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { LeftSidebarComponent } from './components/menus/left_sidebar/left_sidebar.component';
import { RightSidebarComponent } from './components/menus/right_sidebar/right_sidebar.component';
import { ProfileMenuPageTopComponent } from './components/menus/profile_menu_page_top/profile_menu_page_top.component';
import { ProfileMenuComponent } from './components/menus/profile_menu/profile_menu.component';
import { ProfileMenuRepostComponent } from './components/menus/profile_menu_repost/profile_menu_repost.component';
import { ScoreMenuComponent } from './components/menus/score_menu/score_menu.component';
import { TimeStampMenuComponent } from './components/menus/time_stamp_menu/time_stamp_menu.component';
import { ThreeDotsMenuComponent } from './components/menus/three-dots-menu/three-dots-menu.component';

import { CustomSliderComponent } from './components/insertable/custom-slider/custom-slider.component';
import { TruthScoreComponent } from './components/insertable/truth-score/truth-score.component';
import { ReactionsComponent } from './components/insertable/reactions/reactions.component';
import { SearchBarComponent } from './components/insertable/search-bar/search-bar.component';
import { WhoToFollowComponent } from './components/insertable/who-to-follow/who-to-follow.component';
import { TrendingTopicsComponent } from './components/insertable/trending-topics/trending-topics.component';
import { SponsoredPostsComponent } from './components/insertable/sponsored-posts/sponsored-posts.component';
import { MediaCarouselComponent } from './components/insertable/media-carousel/media-carousel.component';
import { PostDetailComponent } from './components/insertable/post-detail/post-detail.component';
import { PostSubmitComponent } from './components/insertable/post-submit/post-submit.component';
import { PostFooterComponent } from './components/insertable/post-footer/post-footer.component';
import { ReplySubmitComponent } from './components/insertable/reply-submit/reply-submit.component';

import { HomeComponent } from './home/home.component';
import { HomeComponent_New } from './components/home/home.component';
import { AdminDashboardComponent } from './components/admin-dashboard/admin-dashboard.component';
import { ProfileComponent } from './components/profile/profile.component';
import { PostComponent } from './components/post/post.component'; // Ensure this is imported 
import { HomeLanding } from './components/home_landing/home_landing.component';
import { PublicHomeComponent } from './components/landing/public-home/public-home.component';
import { TrendingPostCardComponent } from './components/landing/trending-post-card/trending-post-card.component';
import { Sign_In } from './components/authentications/sign_in/sign_in.component';
import { DynamicRouteComponent } from './components/dynamic/dynamic.component';

//import { CounterComponent } from './counter/counter.component';
//import { FetchDataComponent } from './fetch-data/fetch-data.component';

/* Application Routes */
import { AppRoutingModule } from './routing/routing.module'

/* Applicable Service */
import { GlobalService } from './services/global.service'
import { UserService } from './services/user.service'
import { InactivityTimeoutService } from './services/inactivity.timeout.service'
import { FraudIncidentDataService } from './services/fraud_incident.service'
import { UserPostsDataService } from './services/posts.service';
import { EmailService } from './services/email.service';
import { SessionService } from './services/session.service';
import { GIFEmojiService } from './services/gif-emoji.service';

/* Applicable Modals */
import { QuoteModalComponent } from './modals/quote-modal/quote-modal.component';
import { ScoreModalComponent } from './modals/score-modal/score-modal.component';
import { RegistrationComponent } from './modals/sign_up.modal/sign_up.modal.component';
import { RegistrationValidationComponent } from './modals/sign_up_validation.modal/sign_up_validation.modal.component';
import { GifModalComponent } from './modals/gif-modal/gif-modal.component';
import { ProfileEditModalComponent } from './modals/profile-edit-modal/profile-edit-modal.component';
import { ProfileConfirmCloseModalComponent } from './modals/profile-confirm-close-modal/profile-confirm-close-modal.component';
import { PostSubmitModalComponent } from './modals/post-submit-modal/post-submit-modal.component';
import { ReplySubmitModalComponent } from './modals/reply-submit-modal/reply-submit-modal.component';


/* Applicable Pipes */
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { ParseHashtagsPipe } from './pipes/parse-hashtags.pipe';
import { RelativeTimePipe } from './pipes/relative-time.pipe';
import { UniquePipe } from './pipes/unique.pipe';

/* Applicable Guards */
import { AuthGuard } from './guards/auth.guard';

/* Toastr Module for Pop-Ups */
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';


@NgModule({ schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    exports: [
        //LeftSidebarComponent,
        UniquePipe,
        // Other components, pipes, directives
    ],
    declarations: [
        AppComponent,
        CustomSliderComponent,
        TruthScoreComponent,
        ReactionsComponent,
        SearchBarComponent,
        WhoToFollowComponent,
        TrendingTopicsComponent,
        SponsoredPostsComponent,
        MediaCarouselComponent,
        PostDetailComponent,
        PostSubmitComponent,
        PostFooterComponent,
        ReplySubmitComponent,
        NavMenuComponent,
        LeftSidebarComponent,
        RightSidebarComponent,
        ProfileMenuPageTopComponent,
        ProfileMenuComponent,
        ProfileMenuRepostComponent,
        ScoreMenuComponent,
        TimeStampMenuComponent,
        ThreeDotsMenuComponent,
        SafeHtmlPipe,
        HomeComponent,
        AdminDashboardComponent,
        ProfileComponent,
        PostComponent,
        HomeLanding,
        PublicHomeComponent,
        TrendingPostCardComponent,
        Sign_In,
        DynamicRouteComponent,
        QuoteModalComponent,
        ScoreModalComponent,
        RegistrationComponent,
        RegistrationValidationComponent,
        GifModalComponent,
        ProfileEditModalComponent,
        ProfileConfirmCloseModalComponent,
        PostSubmitModalComponent,
        ReplySubmitModalComponent,
        HomeComponent_New,
        ParseHashtagsPipe,
        UniquePipe,
        RelativeTimePipe
        //CounterComponent,
        //FetchDataComponent
        //Modals declarations go here as well
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
        FormsModule,
        ReactiveFormsModule,
        //CarouselModule.forRoot(), // Add .forRoot() on shared module
        CarouselModule, // Add .forRoot() on shared module
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            enableHtml: true, 
            positionClass: 'toast-top-right',
            preventDuplicates: true,
            timeOut: 5000 // 3 seconds timeout
        }),
        //RouterModule.forRoot([
        //  { path: '', component: HomeComponent, pathMatch: 'full' },
        //  { path: 'counter', component: CounterComponent },
        //  { path: 'fetch-data', component: FetchDataComponent },
        //])
        // or declare an AppRoutingModule component. It must be declared last
        AppRoutingModule,
        CommonModule,
        NgbModule /* Add me last */],
    providers: [
        //SafeHtmlPipe,
        GlobalService,
        FraudIncidentDataService,
        UserService,
        InactivityTimeoutService,
        UserPostsDataService,
        AuthGuard,
        EmailService,
        SessionService,
        GIFEmojiService,
        provideHttpClient(withInterceptors([apiBaseUrlInterceptor]))
    ] })
export class AppModule { }
